import { render, staticRenderFns } from "./multi-allocation-dialog.vue?vue&type=template&id=0b96bc1e&scoped=true"
import script from "./multi-allocation-dialog.vue?vue&type=script&lang=js"
export * from "./multi-allocation-dialog.vue?vue&type=script&lang=js"
import style0 from "./multi-allocation-dialog.vue?vue&type=style&index=0&id=0b96bc1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96bc1e",
  null
  
)

export default component.exports